import { render, staticRenderFns } from "./CreateVHost.vue?vue&type=template&id=5e35b046&"
import script from "./CreateVHost.vue?vue&type=script&lang=ts&"
export * from "./CreateVHost.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports